// Shared framer-motion presets. Defined once at module scope so the same object
// reference is reused across renders (avoids creating new prop objects each render).
export const heroReveal = {
  initial: { opacity: 0, y: 40 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.7, delay: 0.2 },
};

export const fadeUpVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 },
};
